<template>
  <transition name="slide-fade">
    <div v-if="isOpen" :class="[dropdownClasses]" @click.stop="closeDropdown">
      <slot />
    </div>
  </transition>
</template>

<script>
export default {
  name: 'UiMenuDropDown',
  props: {
    isOpen: { type: Boolean, default: false },
    isRight: { type: Boolean, default: false },
    disabledStyles: { type: Boolean, default: false },
  },
  emits: ['toggle-is-open'],
  computed: {
    dropdownClasses() {
      if (this.disabledStyles) return ''

      return [
        'absolute border border-primary-gray-50',
        this.isRight
          ? "-right-2.5 before:absolute before:-top-1.5 before:right-2.5 before:w-2.5 before:h-2.5 before:content-[''] before:bg-primary-white before:border-t before:border-l before:border-primary-gray-50 before:rotate-45"
          : '-right-2.5 z-[1]',
        'bg-bg-white py-2 px-2.5',
      ]
    },
  },
  methods: {
    closeDropdown() {
      this.$emit('toggle-is-open', false)
    },
  },
}
</script>
